import React from 'react';

const TwitterIcon = (props) => (
  <svg {...props} viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.5 19.4601C15.7575 19.4601 20.0195 15.2249 20.0195 10.0006C20.0195 4.77621 15.7575 0.541016 10.5 0.541016C5.2425 0.541016 0.980469 4.77621 0.980469 10.0006C0.980469 15.2249 5.2425 19.4601 10.5 19.4601Z'
      fill='black'
      stroke='white'
      strokeMiterlimit='10'
    />
    <path
      d='M4.6361 4.51953L9.18632 10.5652L4.60742 15.4806H5.63803L9.64694 11.177L12.8859 15.4806H16.3929L11.5865 9.09494L15.8486 4.51953H14.818L11.1261 8.48294L8.14305 4.51953H4.6361ZM6.15165 5.27381H7.76273L14.8771 14.7263H13.266L6.15165 5.27381Z'
      fill='white'
    />
  </svg>
);

export default TwitterIcon;
